import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import isToday from "date-fns/isToday";
import format from "date-fns/format";
import constants, { NO_DATA_FOUND } from "../../../../constants";

import { parseDateToLocal } from "../../../../utils/parseDateTime";
import * as actions from "../../../../store/actions";
import AppointmentsCompleted from "../PatientAppointments/AppointmentsCompleted";
import { useInfiniteScroll } from "../../../../utils/pagination";

const PatientAppointments = ({
  getCompletedAppointments,
  appointment,
  resetAppointmentData,
}) => {
  const [page, setPage] = useState(1);

  const aloader = useRef(null);

  useEffect(() => {
    resetAppointmentData();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (page > 0 && page <= appointment.totalPages) {
      getCompletedAppointments(page);
    }
    // eslint-disable-next-line
  }, [page]);

  useInfiniteScroll(aloader, () => {
    setPage(page => page + 1);
  });

  const compltdAppointments = appointment?.completed;

  return (
    <>
      {compltdAppointments && Object.keys(compltdAppointments).length < 1 && (
        <p className="content-center m-auto not-found-image">
          <img
            src={NO_DATA_FOUND}
            width={366}
            height={300}
            alt="requests-not-found"
          />
        </p>
      )}
      {compltdAppointments &&
        Object.keys(compltdAppointments)
          ?.sort()
          ?.reverse()
          .map(obj => (
            <>
              {compltdAppointments[obj]?.length > 0 && (
                <div style={{ marginTop: "1rem", marginLeft: "40px" }}>
                  <span>
                    {isToday(parseDateToLocal(obj))
                      ? "Today"
                      : format(parseDateToLocal(obj), "MMM dd")}
                  </span>
                  <span
                    className="d-inline-block border-bottom ml-2 col-md-11"
                    style={{
                      verticalAlign: "middle",
                    }}
                  ></span>
                  <div className="row p-3">
                    {compltdAppointments[obj].map(reqAppointment => (
                      <>
                        <AppointmentsCompleted
                          appointmentData={reqAppointment}
                        />
                      </>
                    ))}
                  </div>
                </div>
              )}
            </>
          ))}
      <div ref={aloader}></div>
    </>
  );
};

const mapStoreToProps = ({ dashboard }) => ({
  appointment: dashboard.appointments,
});

const mapDispatchToProps = dispatch => ({
  getCompletedAppointments: page =>
    dispatch(
      actions.getAppointments([constants.APPOINTMENT_STATUS.completed], page)
    ),
  resetAppointmentData: () => dispatch(actions.resetAppointmentData()),
});

export default withRouter(
  connect(mapStoreToProps, mapDispatchToProps)(PatientAppointments)
);
